module.exports = __webpack_public_path__ + "static/media/Pipeline-active.839243e7.svg";